import { computeLaps, computeStats } from './lapCalc';
import { classifyLaps } from './pauseLaps';

export function amsterdamDay(value = new Date()) {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(new Date(value));
}

export function timedSessions(
  passings = [],
  overrides = [],
  cfg,
  lane = 'binnenbaan',
  pauseThresholdMs = 70_000,
) {
  const groups = new Map();
  for (const passing of passings) {
    const day = amsterdamDay(passing.rtcTime);
    const key = `${day}__${passing.transponder}`;
    if (!groups.has(key)) groups.set(key, { key, day, transponder: passing.transponder, passings: [] });
    groups.get(key).passings.push(passing);
  }
  return [...groups.values()].map(group => {
    const laps = classifyLaps(
      computeLaps(group.passings, lane, null, cfg),
      overrides.filter(item => item.transponder === group.transponder),
      pauseThresholdMs,
    );
    return {
      key: group.key, day: group.day, transponder: group.transponder,
      laps, stats: computeStats(laps),
      distanceKm: laps.reduce((sum, lap) => sum + lap.distanceM, 0) / 1000,
    };
  }).sort((a, b) => b.day.localeCompare(a.day) || a.transponder.localeCompare(b.transponder));
}

export function summarizeActivity(sessions) {
  const timed = sessions.filter(session => session.stats);
  return {
    sessions: timed.length,
    laps: timed.reduce((sum, session) => sum + session.laps.length, 0),
    distanceKm: timed.reduce((sum, session) => sum + session.distanceKm, 0),
    bestLapMs: timed.length ? Math.min(...timed.map(session => session.stats.bestLapMs)) : null,
  };
}
